<template>
<div>
    <HeaderMember header="เพิ่มลูกค้าส่งเครดิต" :img_header="header_image" link_back="customer" />
    <AddCustomer_Credit/>
</div>
</template>

<script>
import HeaderImage from '@/assets/add-user_1.png'
import HeaderMember from '@/components/admin/member/headermember/HeaderMember.vue'
import AddCustomer_Credit from "@/components/admin/member/customer/AddCustomer_Credit.vue";

export default {
    name: 'addCustomerCredit',
    components: {
        AddCustomer_Credit,
        HeaderMember,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
